// assets/mwc-login.js
//
// Deze versie gebruikt de ingevulde velden op de Shopify pagina zelf.
// Er is dus geen tweede login scherm meer nodig.
//
// Flow:
// 1. user vult email + password in op de shop pagina
// 2. klik op login
// 3. script bouwt een hidden HTML form
// 4. browser doet een normale POST naar auth.watchopedia.watch/login
// 5. auth worker logt de user in en redirect terug naar de store
//
// Voordeel:
// - geen cross-site fetch
// - geen tweede kale loginpagina
// - bestaande gestylede loginpagina blijft in gebruik 
// <!-- test -->

(function () {
  if (window.mwcLoginInitialized) return;
  window.mwcLoginInitialized = true;

  function getEmail() {
    var el = document.getElementById("mwc-email");
    return el ? el.value.trim() : "";
  }

  function getPassword() {
    var el = document.getElementById("mwc-password");
    return el ? el.value : "";
  }

function getEdgeDomain() {
  var env =
    window.mwcConfig && window.mwcConfig.environment === "development"
      ? "development"
      : "production";

  var prefix = env === "development" ? "dev-edge." : "edge.";
  return "https://" + prefix + window.location.host;
}

  function buildHiddenInput(name, value) {
    var input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    return input;
  }

  function submitLogin() {
    var email = getEmail();
    var password = getPassword();
    var store = getEdgeDomain();
    var redirect = window.location.href;
    // var redirect = window.location.origin + "/pages/my-watches";

    if (!email || !password) {
      alert("Vul uw e-mailadres en wachtwoord in.");
      return;
    }

    // Maak een echt HTML form zodat de browser een top-level POST doet.
    // Dit voorkomt de Firefox/cookie problemen van cross-site fetch.
    var form = document.createElement("form");
    form.method = "POST";
    var env =
  window.mwcConfig && window.mwcConfig.environment === "development"
    ? "development"
    : "production";

var authDomain =
  env === "development"
    ? "https://dev-auth.watchopedia.watch"
    : "https://auth.watchopedia.watch";

form.action = authDomain + "/login";
    form.style.display = "none";

    form.appendChild(buildHiddenInput("email", email));
    form.appendChild(buildHiddenInput("password", password));
    form.appendChild(buildHiddenInput("store", store));
    form.appendChild(buildHiddenInput("redirect", redirect));

    document.body.appendChild(form);
    form.submit();
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("#mwc-login-button");
    if (!btn) return;

    e.preventDefault();
    submitLogin();
  });

  document.addEventListener("submit", function (e) {
  var form = e.target;

  if (!form || !form.closest(".mwc-auth-login")) return;

  e.preventDefault();
  submitLogin();
});

// om Enter i.p.v. alleen via OnClick te laten werken, dit toegevoegd:
document.addEventListener("keydown", function (e) {
  var isLoginField =
    e.target &&
    (
      e.target.id === "mwc-email" ||
      e.target.id === "mwc-password"
    );

  if (isLoginField && e.key === "Enter") {
    e.preventDefault();
    submitLogin();
  }
});

})();